module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAABTElEQVQoU42SvUtCYRTGf+eWbm59TKFENLtEUYk3CQoiKIxoCFosIdcgECKoqKVVwQ+IWgqyPyGzkiBa/Asa3Kw21/TE9eqtLKkzve/zPofnnPd5hC+lkRUTIQYaQOhFeQW5R0lI9qLQoop1UNPsZrA/gdTXgQbWVooaGZ4rMSkU3u2mtXAKdOMXchskaTm9ioquLpio5jso/FSsSUh0ee4SZKmjitcL40E4P2tSNCe6OFsB6WsgPh+Uy1Cv2wTrvnMAJxko3tqYUhGdn66hGA1gKw5dBhwfwoAP9o4gm4I7a3qnaqIzwQraVHK7YXffVhoahnQSbq6/Ty76Ijo1kQMj7Ly4XLAdh4ci5NsaLJJYO02OWYb+//eUkO3T6EgK4W+flLQ8PkU/E1GtJhEinRNBFo9n00lEax/1++3sKQEM6UH1DbCzVyo52fsAbzBylAN3nEgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/xuanzhong_press_icon.png
// module id = uwv2
// module chunks = 1